module.exports = __webpack_public_path__ + "808bfcfa52be55791ba3ecf0f732119f.jpg";